// Uses the Webflow blog-post template markup (and its page id, for the same
// fade-in of the heading) so webflow.css styles the long-form copy.
// Keep this in sync with what the site actually does: update it whenever
// analytics, embeds, cookies, Turnstile or a new data processor are added.
export default function PrivacyPolicyPage() {
  return (
    <>
      <section className="section-top padding-0">
        <div style={{ opacity: "0" }} className="content">
          <div className="block-top">
            <h1 className="heading-top">Privacy Policy</h1>
            <p className="paragraph-top blog-post">Last updated: 10 October 2026</p>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="content narrow">
          <div className="post-body">
            <div className="rich-text-block w-richtext">
              <p>
                This policy explains what personal data Abilitics collects through abilitics.com, why we collect it, and the
                rights you have over it. We keep this short because we collect very little.
              </p>

              <h2>Who we are</h2>
              <p>
                The controller of your personal data is Abilitics Ltd (АБИЛИТИКС), UIC 200131838, registered at 58 Strandzha
                Street, 1303 Sofia, Bulgaria. For any privacy question or request, write to{" "}
                <a href="mailto:office@abilitics.com">office@abilitics.com</a>.
              </p>

              <h2>Cookies and tracking</h2>
              <p>
                This website does not use cookies, analytics or advertising trackers, and it does not store anything in your
                browser. Fonts, images and animations are served from our own domain, so visiting the site does not send your
                data to third parties such as Google.
              </p>
              <p>
                The site links to our pages on LinkedIn and Facebook and to the websites of our ventures. Once you follow such a
                link, the privacy policy of that site applies.
              </p>

              <h2>Contact form</h2>
              <p>When you send us a message through the contact form, we collect:</p>
              <ul>
                <li>your email address, and the name and message you choose to give us;</li>
                <li>
                  technical details of the request: your IP address, browser user agent and approximate country, which we use
                  only to detect and block spam and abuse.
                </li>
              </ul>
              <p>
                We use this data to reply to you and to follow up on your enquiry. The legal basis is our legitimate interest in
                responding to people who contact us (Article 6(1)(f) GDPR) and, where your enquiry is about working with us,
                taking steps at your request before entering into a contract (Article 6(1)(b) GDPR).
              </p>
              <p>
                We keep your message only as long as we need it to deal with your enquiry and any follow-up, and then delete it.
                We do not sell your data or use it for marketing.
              </p>

              <h2>Website hosting and server logs</h2>
              <p>
                Like any website, ours receives your IP address and basic request details when you visit, because your browser
                needs them to load the pages. Our hosting provider processes this data to deliver the site and protect it from
                attacks, based on our legitimate interest in running a secure website (Article 6(1)(f) GDPR).
              </p>

              <h2>Service providers</h2>
              <p>We share personal data only with the providers that run the website and the contact form for us:</p>
              <ul>
                <li>
                  <strong>Cloudflare, Inc.</strong> hosts the website, stores contact-form submissions and protects the site
                  against attacks.
                </li>
                <li>
                  <strong>Twilio Inc. (SendGrid)</strong> delivers contact-form messages to our inbox by email.
                </li>
                <li>
                  <strong>Microsoft (Microsoft 365)</strong> hosts our company email, where contact-form messages and any
                  emails you send us are stored.
                </li>
              </ul>
              <p>
                These providers process the data only on our instructions. Cloudflare and Twilio are based in the United
                States, and Microsoft may process data through its affiliates there. These transfers are covered by the EU-U.S.
                Data Privacy Framework and the European Commission's Standard Contractual Clauses.
              </p>

              <h2>Your rights</h2>
              <p>Under the GDPR, you have the right to:</p>
              <ul>
                <li>access the personal data we hold about you and get a copy of it;</li>
                <li>have inaccurate data corrected;</li>
                <li>have your data deleted;</li>
                <li>restrict or object to how we process it;</li>
                <li>receive your data in a portable format.</li>
              </ul>
              <p>
                To use any of these rights, email <a href="mailto:office@abilitics.com">office@abilitics.com</a>. We will reply
                within one month. You can also complain to the Bulgarian Commission for Personal Data Protection
                (<a href="https://www.cpdp.bg/" target="_blank">cpdp.bg</a>) or to the data protection authority in your own
                country.
              </p>

              <h2>Changes to this policy</h2>
              <p>
                If we change how we handle personal data, we will update this page and the date at the top.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
